import React from 'react';
import {ServiceView} from 'shared/models/RouterParam';
import CumulativeHelp from './CumulativeHelp';
import WeatherOverviewHelp from './WeatherOverviewHelp';
import WeekHelp from './WeekHelp';

interface WeatherHelpProps {
  /**
   * to manage which part of the information dialog is shown
   */
  selectedInfo: string;

  onActiveStepChange: (i: number) => void;

  step: number;
}

/**
 * Component to display the totality or different part of the information dialog
 * Contains a button to navigate between the different part of the dialog
 */
const WeatherHelp: React.FC<WeatherHelpProps> = ({
  selectedInfo,
  onActiveStepChange,
  step
}) => {
  React.useEffect(() => {
    switch (selectedInfo) {
      case ServiceView.WEATHER_ACCUMULATION:
        onActiveStepChange(0);
        break;
      case ServiceView.WEATHER_WEEK:
        onActiveStepChange(1);
        break;
      case ServiceView.WEATHER_OVERVIEW:
        onActiveStepChange(2);
        break;
    }
  }, [selectedInfo, onActiveStepChange]);

  const pageShown = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return <CumulativeHelp />;
      case 1:
        return <WeekHelp />;
      case 2:
        return <WeatherOverviewHelp />;
      default: 
        return <CumulativeHelp />;
    }
  };

  return pageShown(step)
};

export default WeatherHelp;
